module.exports = __webpack_public_path__ + "static/media/spinner-white.45fa6a96.svg";